'use client';

import Link from '@/core/i18n/navigation';
import { Modal } from '@/core/components/ui/modal';
import { Button } from '@/core/components/ui/button';
import { useTranslation } from '@/core/components/providers/TranslationProvider';

interface LoginGateModalProps {
    isOpen: boolean;
    onClose: () => void;
    /** Defaults are the price-negotiation wording; other flows (e.g. subscribing) pass their own. */
    title?: string;
    message?: string;
}

export function LoginGateModal({ isOpen, onClose, title, message }: LoginGateModalProps) {
    const { t, tPath } = useTranslation();

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title ?? t('negotiation.login_gate_title', 'Zaloguj się, aby negocjować')}>
            <div className="space-y-4">
                <p className="text-sm text-slate-600">
                    {message ?? t('negotiation.login_gate_message', 'Aby negocjować cenę, zaloguj się lub załóż bezpłatne konto.')}
                </p>
                <div className="flex flex-col sm:flex-row gap-2">
                    <Link href={tPath('/logowanie')} className="flex-1">
                        <Button className="w-full" onClick={onClose}>
                            {t('login.title', 'Zaloguj się')}
                        </Button>
                    </Link>
                    <Link href={tPath('/rejestracja')} className="flex-1">
                        <Button variant="outline" className="w-full" onClick={onClose}>
                            {t('login.register_here', 'Zarejestruj się')}
                        </Button>
                    </Link>
                </div>
            </div>
        </Modal>
    );
}
